@if (href) {
    <svg class="icon">
        <use [attr.href]="href"></use>
    </svg>
}
